module.exports = __webpack_public_path__ + "static/media/faq3x1.881c376f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/faq3x1.png
// module id = 1268
// module chunks = 1